namespace RioERP.Masters {
    export interface WhatsAppTemplateVariableMapRow {
        Id?: number;
        WhatsAppTemplateId?: number;
        WhatsAppTemplateVariableId?: number;
    }

    export namespace WhatsAppTemplateVariableMapRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Masters.WhatsAppTemplateVariableMap';
        export const lookupKey = 'Masters.WhatsAppTemplateVariableMap';

        export function getLookup(): Q.Lookup<WhatsAppTemplateVariableMapRow> {
            return Q.getLookup<WhatsAppTemplateVariableMapRow>('Masters.WhatsAppTemplateVariableMap');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            WhatsAppTemplateId = "WhatsAppTemplateId",
            WhatsAppTemplateVariableId = "WhatsAppTemplateVariableId"
        }
    }
}
